import { Paper } from '@mui/material';
import styled from 'styled-components';

export const AssetLayout = styled.div`
  .MuiGrid-item {
    padding-top: 15px;
    &:first-child {
      padding-top: 17px;
    }
  }
`;

export const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    marginBottom: 15,
    padding: 10,
    borderRadius: 8,
    color: theme.palette.common.black,
  }));